import React, {Component} from 'react';
import {
    Card,
    CardHeader,
    CardActions,
    CardText
} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';

import './code-github.css';

class CodeGithubComponent extends Component {

    render() {
        return (
            <div className="code-github">
              <p className="headline">Look at my code, my code is amazing</p>
                <Card>
                  <CardHeader
                    subtitle="Github Repository"
                    title="rahul/supertest-demo"
                    avatar="github.png"
                  />
                <CardText>
                        This repository contains sample code on running API tests using Supertest.
                    </CardText>
                    <CardActions>
                        <FlatButton label="View on github" href="https://github.com/zac11/supertest-demo" target="_blank"/>
                    </CardActions>
                </Card>
            </div>
        );
    }
}

export default CodeGithubComponent;



// WEBPACK FOOTER //
// ./src/components/code-github/code-github.jsx